import type { GoalsMatchContext, GoalsH2HSection } from '../../../types';

interface ContextPanelProps {
  context: GoalsMatchContext;
  h2h: GoalsH2HSection;
  referee: { name: string | null; photo: string | null; note: string } | null;
}

export function ContextPanel({ context, h2h, referee }: ContextPanelProps) {
  return (
    <div className="goals-panel goals-context-panel">
      {/* Match Context Badges */}
      {context.badges && context.badges.length > 0 && (
        <div className="goals-context-section">
          <h4>Match Context</h4>
          <div className="goals-context-badges">
            {context.badges.map((badge, idx) => (
              <span key={idx} className={`goals-context-badge goals-badge-${badge.type}`}>
                {badge.label}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* H2H Section */}
      {h2h.matches && h2h.matches.length > 0 && (
        <div className="goals-context-section">
          <h4>Head-to-Head</h4>
          <div className="goals-h2h-stats">
            <div className="goals-h2h-stat">
              <span className="goals-h2h-label">Matches</span>
              <span className="goals-h2h-value">{h2h.stats.total_matches}</span>
            </div>
            <div className="goals-h2h-stat">
              <span className="goals-h2h-label">BTTS Rate</span>
              <span className="goals-h2h-value">{(h2h.stats.btts_rate * 100).toFixed(0)}%</span>
            </div>
            <div className="goals-h2h-stat">
              <span className="goals-h2h-label">O2.5 Rate</span>
              <span className="goals-h2h-value">{(h2h.stats.o25_rate * 100).toFixed(0)}%</span>
            </div>
            <div className="goals-h2h-stat">
              <span className="goals-h2h-label">Avg Goals</span>
              <span className="goals-h2h-value">{h2h.stats.avg_goals.toFixed(1)}</span>
            </div>
          </div>
          <div className="goals-h2h-matches">
            <h5>Recent Meetings</h5>
            {h2h.matches.slice(0, 5).map((match, idx) => (
              <div key={idx} className="goals-h2h-match">
                <span className="goals-h2h-date">
                  {match.date ? new Date(match.date).toLocaleDateString() : 'Unknown'}
                </span>
                <span className="goals-h2h-score">
                  {match.home_goals} - {match.away_goals}
                </span>
                {match.btts && <span className="goals-h2h-btts">BTTS</span>}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Referee Section */}
      {referee && referee.name && (
        <div className="goals-context-section goals-referee-section">
          <h4>Referee</h4>
          <div className="goals-referee-info">
            {referee.photo && (
              <img src={referee.photo} alt="" className="goals-referee-photo" />
            )}
            <span className="goals-referee-name">{referee.name}</span>
          </div>
          <p className="goals-referee-note">{referee.note}</p>
        </div>
      )}
    </div>
  );
}

export default ContextPanel;
